import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { saveChain, editEntityField } from '../../../actions';

const languageOptions = ['he', 'en'];

class ChainsEditor extends Component {
    handleSubmit = (event) => {
        this.props.saveChain(this.props.entity);
        event.preventDefault();
    }

    render() {
        const chain = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('name')}</label>
                    <input
                        placeholder={i18next.t('name')}
                        value={chain.name || ''}
                        onChange={({ target }) => this.props.editEntityField('name', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Field>
                    <Dropdown
                        placeholder={i18next.t('general.languages')}
                        fluid
                        selection
                        multiple
                        options={languageOptions.map(value => ({ value, text: i18next.t('languages.' + value) }))}
                        value={chain.languages || []}
                        onChange={(e, { value }) => this.props.editEntityField('languages', value)}
                    />
                </Form.Field>

                {/* <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('websiteSupport')}
                        checked={chain.websiteSupport}
                        onChange={(e, { checked }) => this.props.editEntityField('websiteSupport', checked)}
                    />
                </Form.Field> */}

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

ChainsEditor.propTypes = {
    saveChain: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { saveChain, editEntityField })(ChainsEditor);
